export default __webpack_public_path__ + "static/media/des_1.b224d803.svg";